import urlRegex from 'url-regex-safe';
import qs from 'qs';
import {
  isBooleanLikeString,
  isMongoId,
  isNumberLikeString,
  parseFromStringToBoolean,
  parseFromStringToNumber,
} from 'utils/strings';

/**
 * @see https://github.com/spamscanner/url-regex-safe
 * @see https://github.com/sindresorhus/get-urls/blob/main/index.js
 */
const URL_REGEX = urlRegex();

/**
 * @TODO
 * Utilizar la librería `normalize-url` para normalizar las URLs cuando migremos a Vite
 * dado que la versión que estamos utilizando de CRA no soporta el operador `??`
 *
 * Normaliza una URL
 *
 * @param {string} url
 * @param {object} options
 * @returns {string}
 */
const normalizeUrl = (url, options) => {
  // const defaultOptions = { defaultProtocol: 'https', forceHttps: true };
  // const mergedOptions = { ...defaultOptions, ...options };
  return url.match('^https?://') ? url : `https://${url}`;
};

/**
 * Transforma un objeto a querystring
 * @see https://github.com/ljharb/qs
 * @see https://github.com/ljharb/qs#stringifying
 * @param {Object} arg
 * @param {Object} arg.value
 * @param {Object} arg.options
 * @returns {string}
 */
const parseFromObjectToQueryString = ({ value, options = {} }) => {
  const defaultOptions = { strictNullHandling: true };
  const mergedOptions = { ...defaultOptions, ...options };
  return qs.stringify(value, mergedOptions);
};

/**
 * Decodifica una querystring interpretando los valores como boolean o number
 * @see https://github.com/ljharb/qs
 * @see https://github.com/ljharb/qs#parsing-primitivescalar-values-numbers-booleans-null-etc
 * @see https://github.com/ljharb/qs/issues/91
 * @param {string} str
 * @param {Function} defaultDecoder
 * @param {string} charset
 * @param {string} type
 */
const customQueryStringDecoder = (str, defaultDecoder, charset, type) => {
  const isTypeValue = type === 'value';

  const isBooleanValue = isTypeValue && isBooleanLikeString(str);
  if (isBooleanValue) return parseFromStringToBoolean(str);

  const isMongoIdValue = isTypeValue && isMongoId(str);

  const isNumberValue = isTypeValue && !isMongoIdValue && isNumberLikeString(str);
  if (isNumberValue) return parseFromStringToNumber(str);

  return defaultDecoder(str, defaultDecoder, charset, type);
};

/**
 * Transforma una querystring a objeto
 * @see https://github.com/ljharb/qs
 * @see https://github.com/ljharb/qs#parsing-objects
 * @param {Object} arg
 * @param {string} arg.value
 * @param {Object} arg.options
 * @return {Object}
 */
const parseFromQueryStringToObject = ({ value, options = {} }) => {
  const defaultOptions = {
    strictNullHandling: true,
    ignoreQueryPrefix: true,
    decoder: customQueryStringDecoder,
  };
  const mergedOptions = { ...defaultOptions, ...options };
  return qs.parse(value, mergedOptions);
};

export { URL_REGEX, normalizeUrl, parseFromObjectToQueryString, parseFromQueryStringToObject };
